export default [
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NR-01',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: '',
        error_id: 'NR-02',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NR-ICS-01',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: '',
        error_id: 'NR-ICS-02',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    }
]